import "./Geography.scss";

import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "../../ui";
import { CardWhite, GeographyData, RechartsPie } from "../../widgets";
import { useEffect, useState } from "react";
import { DOMAIN_API_HOST } from "../../configs/main";

function Geography({ counter_id, date_from, date_to, selected_campaigns = [] }) {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const geoMap = new Map();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setData([]);

        let url = `${DOMAIN_API_HOST}/api/v1/ya-metrika/stat/geo?counter_id=${counter_id}&date_from=${date_from?.toLocaleDateString(
          "en-CA"
        )}&date_to=${date_to?.toLocaleDateString("en-CA")}`;

        const campaigns = (selected_campaigns || []).filter(
          (id) => id && id !== "all_campaigns" && id !== "0"
        );

        campaigns.forEach((id) => {
          url = url.concat(`&campaign_ids=${id}`);
        });

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (!response.ok) {
          return setData([]);
        }

        const data = await response.json();
        setData(data);

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (counter_id) {
      fetchData();
    }
  }, [counter_id, date_from, date_to, selected_campaigns]);

  if (!counter_id) {
    return (
      <div className="Geography">
        <CardWhite>
          <Typography variant="h2" color="dark-gray">
            География
          </Typography>
          <center style={{ marginTop: "60%" }}>Выберите счётчик</center>
        </CardWhite>
      </div>
    );
  }

  for (const item of data) {
    const regionName = item.name;
    const regionValue = item.value;

    geoMap.set(regionName, (geoMap.get(regionName) || 0) + regionValue);
  }

  let geoItems = Array.from(geoMap.entries())
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 5);

  const total = geoItems.reduce((sum, item) => sum + item.value, 0);

  geoItems = geoItems.map((item, index, array) => {
    const percent = total > 0 ? (item.value / total) * 100 : 0;
    if (index === array.length - 1) {
      const sumPrev = array.slice(0, -1).reduce((s, i) => s + (i.value / total) * 100, 0);
      return {
        id: index,
        name: item.name,
        value: Number((100 - sumPrev).toFixed(2))
      };
    }
    return {
      id: index,
      name: item.name,
      value: Number(percent.toFixed(2))
    };
  });

  const colors = ["#3f73f9", "#f9a93f", "#3ff97a", "#a864f8", "gray"];
  const allZeros = data.length > 0 && data.every(item => item.value === 0);
  
  return (
    <div className="Geography">
      <CardWhite>
        <Typography variant="h2" color="dark-gray">
          География
        </Typography>
        {isLoading ? (
          <div className="widget-loader">
            <CircularProgress size={22} sx={{ color: "#3f73f9" }} />
            <span>Загрузка данных...</span>
          </div>
        ) : allZeros || geoItems.length === 0 ? (
          <center style={{ marginTop: "60%" }}>Данные не найдены</center>
        ) : (
          <>
            <div className="graph">
              <RechartsPie geoItems={geoItems} colors={colors} />
            </div>

            <div style={{ marginTop: "20px" }}>
              {geoItems.map((geoItem, index) => (
                <GeographyData
                  name={geoItem.name}
                  value={geoItem.value}
                  color={colors[index % colors.length]}
                  key={geoItem.id}
                />
              ))}
            </div>
          </>
        )}
      </CardWhite>
    </div>
  );
}

export default Geography;
